export default __webpack_public_path__ + "static/media/tivitAvatar.f5aa06bf.svg";